export default "__VITE_ASSET__BjzJpEqk__"